import { CashierShiftTransaction } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { SidePanel } from '@mews/b2b-ui';
import { TransactionDetailContent } from './TransactionDetailContent';

interface Props {
    transaction: CashierShiftTransaction;
    opened: boolean;
    onClose: () => void;
}

export const TransactionDetailPanel = ({ transaction, onClose, opened }: Props) => {
    return (
        <SidePanel
            opened={opened}
            onClose={onClose}
            headerActions={null}
            title={lt('CashierReceiptTransaction')}
            width="medium"
            content={<TransactionDetailContent transaction={transaction} />}
        />
    );
};
